/* *************************
 * 	hover actions
 * ************************* */
var hoverActions = {
	init:function(){
	    $('.hover-add-class').mouseenter(function(e) {
	    	var target = $(e.currentTarget);
	    	var css_selector = target.data('hv-selector');
	    	var css_class = target.data('hv-class');
	    	if (typeof(css_selector) == 'undefined' || css_selector == '') css_selector = e.currentTarget;
	    	$(css_selector).addClass(css_class);
	    }).mouseleave(function(e) {
	    	var target = $(e.currentTarget);
	    	var css_selector = target.data('hv-selector');
	    	var css_class = target.data('hv-class');
	    	if (typeof(css_selector) == 'undefined' || css_selector == '') css_selector = e.currentTarget;
	    	$(css_selector).removeClass(css_class);
	    });
	}
};

$(document).ready(function() {
	hoverActions.init();
});

/* *******************
 * Comfortcontact
 * ****************** */
function showComfortcontact(){
	$('.comfortcontact-box').addClass('show-box');
	$('BODY').addClass('comfortcontact-open');
}
function hideComfortcontact(){
	$('.comfortcontact-box').removeClass('show-box');
	$('BODY').removeClass('comfortcontact-open');
}

$(document).ready(function () {
	$( ".btn-comfortcontact" ).hover(
	      function() {
	    	showComfortcontact();
	      },
	      function() {
	      	$(document).on("mouseleave",'.comfortcontact-box, .btn-comfortcontact', function () { 
	      		if($(".comfortcontact-box:hover").length != 0) return;
				hideComfortcontact();
	      		$(document).off('mouseleave', '.comfortcontact-box, .btn-comfortcontact');
			});
	      }
	);
	$( ".btn-comfortcontact" ).click(function() {
		showComfortcontact(this);
		$(document).on("mouseup.hideDocClick", function () { hideComfortcontact();$(document).off('.hideDocClick'); });
	});
});

/* *************************
 * 	nav
 * ************************* */
window.nav = {
	menuContainerId : 'main-menu',
	navbarNavSelector : '#mainnav .navbar-nav',
	dropdown : $("#mainnav .navbar-nav > .dropdown"),
	dropdownDropdown : $("#mainnav .navbar-nav .dropdown .dropdown > .dropdown-item"),
	dropdownToggle : $(".dropdown-toggle"),
	dropdownMenu : $(".dropdown-menu"),
	showClass : "show",
	navMobiledDdClass : '.mobile-dd-toggle',
	navMobileBreakpoint:0,
	init:function(){
		nav.dropdown.hover(
	      function() {
			if ($(window).width() > nav.navMobileBreakpoint) nav.openHoverMenu(this);
	      },
	      function() {
	  		if ($(window).width() > nav.navMobileBreakpoint) nav.closeHoverMenu();
	      }
	    );
	    $(nav.navbarNavSelector + ' .nav-link, ' + nav.navbarNavSelector + ' .dropdown-item').on('click', function() {
	        $('#' + nav.menuContainerId).collapse('hide');
	    });
		/* mobile-dd-toggle */
		if (nav.navMobiledDdClass != '') {
			$("#mainnav " + nav.navMobiledDdClass).click(nav.switchMobileDdToggle);
	        $("#mainnav " + nav.navMobiledDdClass).keydown(function(e) {
		        if (e.key === "Enter") nav.switchMobileDdToggle(e);
	        });
		}
	},
	switchMobileDdToggle:function(e) {
			if ($(e.currentTarget).attr("aria-expanded") == 'false') {
		        nav.openMenu($(e.currentTarget).closest('.dropdown'));
			} else {
		        nav.closeMenu($(e.currentTarget).closest('.dropdown'));
			}
	    	e.stopPropagation();
	        e.preventDefault();
	},
	openMenu:function(e){
		var $this = $(e);
	    $this.addClass(nav.showClass);
	    $this.children(nav.dropdownToggle).attr("aria-expanded", "true");
	    $this.children(nav.dropdownMenu).addClass(nav.showClass);
		$this.children(nav.dropdownToggle).children(nav.navMobiledDdClass).attr("aria-expanded", "true");
	},
	closeMenu:function(e){
		if (e) {
	    	var $this = e;			
		} else {
	    	var $this = $(nav.dropdown);
		}
        $this.removeClass(nav.showClass);
        $this.children(nav.dropdownToggle).attr("aria-expanded", "false");
        $this.children(nav.dropdownMenu).removeClass(nav.showClass);
		$this.find(nav.navMobiledDdClass).attr("aria-expanded", "false");
	},
	openHoverMenu:function(e){
		nav.closeHoverMenu();
		nav.openMenu(e);
		nav.dropdown.click(
	      function(e) {
                nav.closeHoverMenu();
		});
	},
	closeHoverMenu:function(e){
		nav.closeMenu(nav.dropdown);			
	},
};

// SwitchHeader — Flexibler Wechsel von Zuständen beim Scrollen (Mehrfach nutzbar)
// Nutzung:
// 1) Ziel-Elemente anlegen, z. B. <div id="switchheader"></div> und <div id="subnav"></div>
// 2) Instanzen mit "new" initialisieren (beliebig viele möglich):
//    const headerSwitch = new window.SwitchHeader({
//      selector: '#switchheader',
//      switchPosition: '300',
//      before: () => document.querySelector('.header-bgcontainer').classList.add('bg-secondary'),
//      after:  () => document.querySelector('.header-bgcontainer').classList.remove('bg-secondary'),
//      debounceMs: 60, // optional, Standard: 80
//      offset: 0       // optional, Standard: 0
//    });
//
//    const navSwitch = new window.SwitchHeader({
//      selector: '#subnav',
//      switchPosition: '500',
//      before: () => document.querySelector('.subnav').classList.add('fixed'),
//      after:  () => document.querySelector('.subnav').classList.remove('fixed')
//    });
//
//    - before wird ausgeführt, wenn das Fenster die Position des Elements erreicht oder überschreitet.
//    - after wird ausgeführt, wenn das Fenster wieder oberhalb der Position ist.
//    - Existiert das Element nicht, wird before sofort ausgeführt (wie im Original).
// 3) Methoden auf der jeweiligen Instanz aufrufen:
//    headerSwitch.trigger()           // manueller Check für diese Instanz
//    headerSwitch.setSelector('#id')  // Selector für diese Instanz ändern

// SwitchHeader — Flexibler Wechsel von Zuständen beim Scrollen (Mehrfach nutzbar)
window.SwitchHeader = function (config) {
  const noop = () => {};

  function debounce(fn, wait = 0) {
    if (wait === 0) return fn; // Falls debounceMs: 0 übergeben wird
    let t = null;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  this.selector = config.selector || '#switchheader';
  this.switchPosition = config.switchPosition !== undefined ? Number(config.switchPosition) : null;
  this.onBefore = config.before || noop;
  this.onAfter = config.after || noop;
  this.offset = config.offset !== undefined ? Number(config.offset) : 0;
  this.debounceMs = config.debounceMs !== undefined ? config.debounceMs : 80;
  
  this.lastState = null;
  this.element = null;

  this.updateElement = function () {
    this.element = document.querySelector(this.selector);
  };

  const getOffsetTop = (el) => {
    if (!el) return null;
    const rect = el.getBoundingClientRect();
    return rect.top + window.pageYOffset;
  };

  this.check = function () {
    let basePosition = 0;
    const elTop = getOffsetTop(this.element);

    if (elTop !== null) {
      basePosition = elTop;
    } else if (this.switchPosition !== null) {
      basePosition = this.switchPosition;
    } else {
      return; // Weder Element noch feste Position vorhanden
    }

    const threshold = basePosition + this.offset;
    const isPast = window.pageYOffset >= threshold;

    if (isPast && this.lastState !== 'before') {
      this.lastState = 'before';
      this.onBefore();
    } else if (!isPast && this.lastState !== 'after') {
      this.lastState = 'after';
      this.onAfter();
    }
  };

  this.setSelector = function (newSelector) {
    this.selector = newSelector;
    this.updateElement();
    this.trigger();
  };

  this.trigger = function () {
    this.check();
  };

  // Initialisierung beim Erstellen
  this.updateElement();
  
  // Falls weder Element existiert noch eine feste Position übergeben wurde, wird 'before' ausgeführt.
  // Wenn eine switchPosition existiert, nutzen wir diese für den ersten Check.
  if (!this.element && this.switchPosition === null) {
    this.onBefore();
    this.lastState = 'before';
  } else {
    this.check();
  }

  // Scroll-Event registrieren
  window.addEventListener('scroll', debounce(() => this.check(), this.debounceMs));
};



/**
 * SmoothScrollHandler
 * 
 * Verwendung:
 * const scrollHandler = new SmoothScrollHandler({ 
 *    offset: 140,            // Standard Offset für normale Anker
 *    accordionOffset: 100,   // Spezieller Offset für Accordion-Elemente
 *    speed: 600              // Animationsgeschwindigkeit in ms
 * });
 * 
 * Voraussetzung: jQuery und Bootstrap JS müssen geladen sein.
 */
class BootstrapScrollHandler {
    constructor(options = {}) {
        // Zwei verschiedene Offsets konfigurierbar
        this.defaultOffset = options.offset || 140;
        this.accordionOffset = options.accordionOffset || 90; 
        this.speed = options.speed || 600;
        
        // CSS Smooth Scroll deaktivieren für volle JS-Kontrolle
        $('html').css('scroll-behavior', 'auto !important');
        
        this.init();
    }

    init() {
        // 1. Initialer Check (Deep Link)
        $(window).on('load', () => {
            if (window.location.hash) {
                window.scrollTo(0, 0); 
                setTimeout(() => this.handleTarget(window.location.hash), 100);
            }
        });

        // 2. Klick-Handler
        $(document).on('click', 'a[href*="#"]', (e) => {
            const link = e.currentTarget;
            if (link.pathname === window.location.pathname && link.hash) {
                e.preventDefault();
                e.stopImmediatePropagation();
                
                this.handleTarget(link.hash);
                history.pushState(null, null, link.hash);
            }
        });
    }

    handleTarget(hash) {
        const $target = $(hash);
        if (!$target.length) return;

        // Fallunterscheidung: Accordion vs. normaler Anker
        const isAccordion = $target.hasClass('collapse') || $target.hasClass('accordion-collapse');
        const currentOffset = isAccordion ? this.accordionOffset : this.defaultOffset;

        if (isAccordion) {
            if ($target.hasClass('show')) {
                this.scrollToElement($target, currentOffset);
            } else {
                // Erst scrollen, wenn Bootstrap fertig ausgeklappt hat (verhindert Ruckeln)
                $target.one('shown.bs.collapse', () => {
                    this.scrollToElement($target, currentOffset);
                });
                $target.collapse('show');
            }
        } else {
            this.scrollToElement($target, currentOffset);
        }
    }

    scrollToElement($element, offsetValue) {
        // Position erst bei Funktionsaufruf messen (wichtig nach dem Aufklappen!)
        const targetPos = $element.offset().top - offsetValue;

        $('html, body').stop(true).animate({
            scrollTop: targetPos
        }, this.speed, 'swing');
    }
}
window.BootstrapScrollHandler = BootstrapScrollHandler;


/**
 * Gutenberg Akkordeon-Element bei Seitenaufruf öffnen, falls Seite entsprechenden Hash enthält 
 * 
 */
jQuery(document).ready(function($) {
    function openAccordionByHash() {
        var hash = window.location.hash;
        if (!hash) return;

        // Findet das Element mit der ID aus der URL
        var $target = $(hash);
        if ($target.length === 0) return;

        // Prüft, ob das Element im oder am Accordion liegt
        var $accordionItem = $target.closest('.wp-block-accordion-item');
        if ($accordionItem.length) {
            // Findet den Button und prüft, ob das Accordion noch geschlossen ist
            var $button = $accordionItem.find('.wp-block-accordion-heading__toggle');
            if ($button.attr('aria-expanded') === 'false') {
                // Simuliert den Klick, damit das Interactivity-API-Script triggert
                $button.trigger('click');
                
                // Scrollt sanft zum Element nach dem Öffnen
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $target.offset().top - 40 // 40px Puffer nach oben
                    }, 300);
                }, 100);
            }
        }
    }

    // 1. Beim Laden der Seite ausführen
    // Nutzen Sie setTimeout, falls das Gutenberg-Script etwas länger zum Laden braucht
    setTimeout(openAccordionByHash, 200);

    // 2. Ausführen, wenn sich der Hash ändert, ohne dass die Seite neu lädt
    $(window).on('hashchange', openAccordionByHash);
});
